import styled from 'styled-components';

import { UserProfileIcon } from '../../assets';

const StyledUserProfileIcon = styled(UserProfileIcon)`
  stroke: ${({ theme }) => theme.colors.primary.c300};
`;

export default StyledUserProfileIcon;
